import { api } from "api/api";

export interface Request {
    code: string;
}
interface ResponseData {
    link: string;
}
interface Response {
    returnCode: number;
    data: ResponseData
}

export async function getAppointmentConfirmLink({ code }: Request): Promise<Response> {
    const url = `api/mobile/appointment/confirm/link/${code}`;
    const response = await api.get(url);
    return response.data;
}
